import { FC } from 'react';
import { BaseLender } from '../../shared/models';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { CerebroLabel } from '../../shared/components';

export interface ILenderListDisplay {
	lenderType: 'Excluded' | 'Reduced Fee';
	memberList: BaseLender[];
}

export const LenderListDisplay: FC<ILenderListDisplay> = ({ lenderType, memberList }) => {
	return (
		<>
			{lenderType == 'Excluded' && <CerebroLabel sx={{ marginTop: 3 }}>Excluded Lenders</CerebroLabel>}
			{lenderType == 'Reduced Fee' && <CerebroLabel sx={{ marginTop: 3 }}>Reduced Fee Lenders</CerebroLabel>}
            <Table>
				<TableBody>
					{memberList.map(member => {
						return (
							<TableRow key={member.bankGuid}>
								<TableCell>
									{member.bankName}
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</>
	);
};
